module.exports = function($scope) {
  
  function init() {
  }
  
  $scope.ok = function() {
    $scope.closeThisDialog({ action: "ok", rejectReason: $scope.rejectReason });
  }
  
  $scope.cancel = function() {
    $scope.closeThisDialog({ action: "cancel" });
  }
  
  init();
}
